export const RIM_TEXT_CIRCLE_MAX_LENGTH = 58
export const RIM_TEXT_SQUARE_MAX_LENGTH = 22
